import { CONST } from "./CONST"
//Ctrl + Click to CONST To view statues

export interface VisaPageFilterItem {
    page: 'CURRENT_VISAS' | 'VISA_ORDERS' | 'ACTIVE_VISAS' | 'CANCELED_VISAS',
    filters: {
        SUPER_ADMIN: Array<number>,
        AGENT: Array<number>
    }
}

export const VISA_PAGES_FILTER: VisaPageFilterItem[] = [
    {
        page: 'CURRENT_VISAS',
        filters: {
            SUPER_ADMIN: [1, 4, 5, 6 , 8, 10],
            AGENT: [0, 1, 2, 4, 5, 6 , 8, 10]
        }
    }
]

export const createStatusParam = (page: VisaPageFilterItem['page'], role: 'SUPER_ADMIN' | 'AGENT') => {

    const pageFilter = VISA_PAGES_FILTER.find(i => i.page == page)

    if (!pageFilter) return ''

    if (role === 'SUPER_ADMIN') return `status=${pageFilter.filters.SUPER_ADMIN.join(',')}`

    else if (role === 'AGENT') return `status=${pageFilter.filters.AGENT.join(',')}`

    return ''

}